class CatalogSidebarController extends HTMLElement {
  constructor() {
    super();
    this.alignToCollectionGrid = this.alignToCollectionGrid.bind(this);
    this.handleMenuToggle = this.handleMenuToggle.bind(this);
  }

  connectedCallback() {
    this.sidebar = this.closest('.catalog-page-shell__sidebar');
    this.pageShell = this.closest('.catalog-page-shell');
    this.mainContent = this.pageShell?.querySelector('#MainContent');
    this.menuToggles = this.querySelectorAll('.catalog-menu__toggle');

    this.menuToggles.forEach((toggle) => toggle.addEventListener('click', this.handleMenuToggle));
    window.addEventListener('resize', this.alignToCollectionGrid);

    if (typeof ResizeObserver === 'function' && this.mainContent) {
      this.layoutObserver = new ResizeObserver(this.alignToCollectionGrid);
      this.layoutObserver.observe(this.mainContent);

      const collectionHero = this.mainContent.querySelector('.collection-hero');
      if (collectionHero) this.layoutObserver.observe(collectionHero);
    }

    this.alignToCollectionGrid();
    document.fonts?.ready.then(() => {
      if (this.isConnected) this.alignToCollectionGrid();
    });

    this.querySelectorAll('.catalog-menu__note').forEach((note) => {
      const trigger = note.querySelector('.catalog-menu__note-trigger');
      if (!trigger) return;

      trigger.addEventListener('focus', () => note.classList.remove('is-tooltip-dismissed'));
      trigger.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;

        note.classList.add('is-tooltip-dismissed');
        trigger.blur();
      });
      note.addEventListener('mouseenter', () => note.classList.remove('is-tooltip-dismissed'));
      note.addEventListener('mouseleave', () => note.classList.remove('is-tooltip-dismissed'));
    });
  }

  disconnectedCallback() {
    this.menuToggles.forEach((toggle) => toggle.removeEventListener('click', this.handleMenuToggle));
    window.removeEventListener('resize', this.alignToCollectionGrid);
    this.layoutObserver?.disconnect();
  }

  alignToCollectionGrid() {
    if (!this.sidebar || !this.pageShell || !this.mainContent) return;

    const layoutAnchor =
      this.mainContent.querySelector('#main-collection-filters') ||
      this.mainContent.querySelector('#ProductGridContainer');

    if (!layoutAnchor) {
      this.sidebar.style.removeProperty('--catalog-sidebar-offset');
      return;
    }

    if (layoutAnchor !== this.layoutAnchor) {
      this.layoutAnchor = layoutAnchor;
      this.layoutObserver?.observe(layoutAnchor);
    }

    const shellTop = this.pageShell.getBoundingClientRect().top;
    const anchorTop = layoutAnchor.getBoundingClientRect().top;
    const offset = Math.max(0, Math.round(anchorTop - shellTop));

    this.sidebar.style.setProperty('--catalog-sidebar-offset', `${offset}px`);
  }

  handleMenuToggle(event) {
    const toggle = event.currentTarget;
    const submenu = document.getElementById(toggle.getAttribute('aria-controls'));

    if (!submenu || !this.contains(submenu)) return;

    const shouldOpen = toggle.getAttribute('aria-expanded') !== 'true';

    toggle.setAttribute('aria-expanded', String(shouldOpen));
    submenu.hidden = !shouldOpen;
  }
}

if (!customElements.get('catalog-sidebar-controller')) {
  customElements.define('catalog-sidebar-controller', CatalogSidebarController);
}
